import React from 'react';
import {Modal} from "react-bootstrap";
import Table from "react-bootstrap/Table";

const ServiceChargeInfo = ({isOPen, onClose, data}) => {
    return (
        <Modal show={isOPen} onHide={onClose}>
            <Modal.Header closeButton={true}>
                <h6> Service Charge Information</h6>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {
                        data?.length > 0 ?

                            <div>
                                <Table striped bordered hover>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Price</th>
                                        <th>Discounted Price</th>

                                    </tr>
                                    </thead>
                                    <tbody>

                                    {
                                        data.map((room) => (
                                            <tr key={room?.id}>
                                                <td>1</td>
                                                <td>{room?.name}</td>
                                                <td>{room?.price} TK</td>
                                                <td>{room?.discounted_price} TK</td>


                                            </tr>
                                        ))
                                    }


                                    </tbody>
                                </Table>
                            </div>

                            : <h6 className='text-center'>NO Data</h6>
                    }

                </div>

            </Modal.Body>

        </Modal>
    );
};

export default ServiceChargeInfo;